'use client'

import {
    Box,
    chakra,
    Container,
    Image,
    Stack,
    Text,
    useColorModeValue,
    VisuallyHidden,
} from '@chakra-ui/react'
import { FaInstagram, FaTwitter, FaYoutube } from 'react-icons/fa'
import { ReactNode } from 'react'
import logo from '../../assets/logo.png';


const SocialButton = ({
    children,
    label,
    href,
}) => {
    return (
        <chakra.button
            bg={useColorModeValue('blackAlpha.100', 'whiteAlpha.100')}
            rounded={'full'}
            w={8}
            h={8}
            cursor={'pointer'}
            as={'a'}
            href={href}
            display={'inline-flex'}
            alignItems={'center'}
            justifyContent={'center'}
            transition={'background 0.3s ease'}
            _hover={{
                bg: useColorModeValue('blackAlpha.200', 'whiteAlpha.200'),
            }}>
            <VisuallyHidden>{label}</VisuallyHidden>
            {children}
        </chakra.button>
    )
}

export default function SmallWithLogoLeft() {
    return (
        <Box
            position="fixed"
            left={0}
            right={0}
            bottom={0}
            bg={useColorModeValue('gray.50', 'gray.700')}
            color={useColorModeValue('gray.700', 'gray.200')}>
            <Container
                as={Stack}
                maxW={'6xl'}
                py={3}
                direction={{ base: 'column', md: 'row' }}
                spacing={4}
                justify={{ base: 'center', md: 'space-evenly' }}
                align={{ base: 'center', md: 'center' }}>
                <Text>© 2024 Arora. All rights reserved</Text>
                {/* <Stack direction={'row'} spacing={6}>
                    <SocialButton label={'Twitter'} href={'#'}>
                        <FaTwitter />
                    </SocialButton>
                </Stack> */}
                <div className='powered-by-section'>
                    <Text align="right" ml="auto">Powered by &#xA0;</Text>
                    <Image src={logo} alt="Powered by Logo" className='logo-footer' />
                </div>
            </Container>
        </Box>
    )
}